module.exports = __webpack_public_path__ + "img/icon-ywqn-banner-2.c96c5e5d.png";